export default __webpack_public_path__ + "static/media/how-to.c0476c7e.svg";